<template>
  <div>
    <!-- PC端 -->
    <div class="home" v-if="isPC">
      <!-- 顶部介绍区域 -->
      <div class="introduce">
        <div class="container">
          <div class="home-banner">
            <div class="title">
              <h1>{{ $t('Home.Home.Tips1') }}</h1>
              <p>{{ $t('Home.Home.Tips2') }}</p>
            </div>
            <div class="sub-title">
              <ul class="f f-b-c">
                <li>{{ $t('Home.Home.VerifiedSuppliers') }}</li>
                <li>{{ $t('Home.Home.SpecializingIn') }}</li>
                <li>{{ $t('Home.Home.NoFulfillment') }}</li>
                <li>{{ $t('Home.Home.DailyUpdate') }}</li>
              </ul>
              <p>{{ $t('Home.Home.StablyCooperated') }} </p>

            </div>

            <div class="register">
              <el-button v-if="userId" @click="jumpHref('/mall')">{{ $t('Dropshipping.Module1.StartSelling') }}</el-button>
            <el-button v-else @click="jump('/register')">{{ $t('Dropshipping.Module1.SignUpForFree') }}</el-button>
            </div>
            <div class="sample-display f-c-c">
              <!-- <iframe width="100%" height="100%" style="border: 2px solid #9AC331;border-radius: 12px;" src="https://www.youtube.com/embed/oK3gWeyJm80?si=SVm2cgSaf2MfMZbH" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> -->
              <div class="play-img pointer" @click="playPCVideo('https://img.kakaclo.com/web-img/home/video/video/introduce.mp4')">
                <oss-img :width="40" :height="40" src="https://img.kakaclo.com/web-img/home/home2.0/Slice%202546%202x.png" alt="img" />
              </div>
            </div>
          </div>
        </div>
        <div class="introduce-advantage-list f f-b-c">
          <div class="introduce-advantage">
            <oss-img :width="24" :height="24" src="https://img.kakaclo.com/web-img/home/Slice%202583%402x.png" alt="img" />
            <h3>{{ $t('Home.Home.Quality') }}</h3>
            <h6>{{ $t('Home.Home.StrictQC') }}</h6>
            <p>{{ $t('Home.Home.EverySingle') }}</p>
          </div>
          <div class="introduce-advantage">
            <oss-img :width="24" :height="24" src="https://img.kakaclo.com/web-img/home/Slice%202584%402x.png" alt="img" />
            <h3>{{ $t('Home.Home.Prices') }}</h3>
            <h6>{{ $t('Home.Home.StartFrom') }}</h6>
            <p>{{ $t('Home.Home.StablyCooperatedWith') }}</p>
          </div>
          <div class="introduce-advantage">
            <oss-img :width="24" :height="24" src="https://img.kakaclo.com/web-img/home/Slice%202586%402x.png" alt="img" />
            <h3>{{ $t('Home.Home.Styles') }}</h3>
            <h6>SKU 1,000,000+ </h6>
            <p>{{ $t('Home.Home.AllCategories') }}</p>
          </div>
          <div class="introduce-advantage">
            <oss-img :width="24" :height="24" src="https://img.kakaclo.com/web-img/home/Slice%202585%402x.png" alt="img" />
            <h3>{{ $t('Home.Home.OnTrend') }}</h3>
            <h6>{{ $t('Home.Home.DailyUpdate1000') }}</h6>
            <p>{{ $t('Home.Home.MoreThan1000') }}</p>
          </div>
        </div>
      </div>

      <!-- 产品轮播图区域 -->
      <div class="banner-box">
        <div class="banner">
          <Banner />
          <div class="pointer" @click="jump('/album/kakaclo-latest-fashion-arrivals', 542)">{{ $t('Home.Home.ViewAll') }} <i class="iconfont icon-arrow-right-line"></i></div>
        </div>
      </div>

      <!-- 商品展示区域 -->
      <div class="goods-exhibition">
        <h2>{{ $t('Home.Mobile.ClothingWholesale') }}</h2>
        <div class="content">
          <div class="content-top f">
            <div class="img-box">
              <div class="img-description">
                <div>
                  <h2>{{ $t('Home.Home.Tops') }}</h2>
                  <a href="/product-list/women/tops" target="_blank"> <el-button type="primary"> {{$t('Home.Home.ShopNow')}}</el-button></a>
                </div>
              </div>
              <oss-img :width="584" :height="320" style="border-radius: 12px 0px 0px 0px;" src="https://img.kakaclo.com/web-img/home/Slice%202589%402x(2).png" alt="img" />
            </div>
            <div class="img-box">
              <div class="img-description">
                <div>
                  <h2>{{ $t('Home.Home.Blouses') }}</h2>
                  <a href="/product-list/women/tops-shirts-blouses" target="_blank"><el-button type="primary"> {{$t('Home.Home.ShopNow')}}</el-button></a>
                </div>
              </div>
              <oss-img :width="248" :height="320" src="https://img.kakaclo.com/web-img/home/Slice%202589%402x(1).png" alt="img" />
            </div>
            <div class="img-box">
              <div class="img-description">
                <div>
                  <h2>{{ $t('Home.Home.Dress') }}</h2>
                  <a href="/product-list/women/dresses" target="_blank"><el-button type="primary">{{$t('Home.Home.ShopNow')}}</el-button></a>
                </div>
              </div>
              <oss-img :width="248" :height="320" src="https://img.kakaclo.com/web-img/home/Slice%202589%402x(3).png" alt="img" />
            </div>
            <div class="img-box">
              <div class="img-description">
                <div>
                  <h2>{{ $t('Home.Home.Jumpsuit') }}</h2>
                  <a href="/product-list/Women/Jumpsuits-Rompers-Jumpsuits" target="_blank"> <el-button type="primary"> {{$t('Home.Home.ShopNow')}} </el-button></a>
                </div>
              </div>
              <oss-img :width="248" style="border-radius: 0px 12px 0px 0px;" :height="320" src="https://img.kakaclo.com/web-img/home/Slice%202589%402x(4).png" alt="img" />
            </div>
          </div>
          <div class="content-bottom f">
            <div class="img-box">
              <div class="img-description" style="border-radius: 0px 0px 0px 12px;">
                <div>
                  <h2>{{ $t('Home.Home.Lingerie') }}</h2>
                  <a href="/product-list/women/lingerie" target="_blank"><el-button type="primary">{{$t('Home.Home.ShopNow')}}</el-button></a>
                </div>
              </div>
              <oss-img :width="248" :height="320" style="border-radius: 0px 0px 0px 12px;" src="https://img.kakaclo.com/web-img/home/Slice%202589%402x(5).png" alt="img" />
            </div>
            <div class="img-box">
              <div class="img-description">
                <div>
                  <h2>{{ $t('Home.Home.Denim') }}</h2>
                  <a href="/product-list/Women/Jeans-Denim" target="_blank"><el-button type="primary">{{$t('Home.Home.ShopNow')}}</el-button></a>
                </div>
              </div>
              <oss-img :width="584" :height="320" src="https://img.kakaclo.com/web-img/home/Slice%202589%402x(6).png" alt="img" />
            </div>
            <div class="img-box">
              <div class="img-description">
                <div>
                  <h2>{{ $t('Home.Home.Sport') }}</h2>
                  <a href="/product-list/Women/Activewear" target="_blank"> <el-button type="primary"> {{$t('Home.Home.ShopNow')}}</el-button></a>
                </div>
              </div>
              <oss-img :width="248" :height="320" src="https://img.kakaclo.com/web-img/home/Slice%202589%402x.png" alt="img" />
            </div>
            <div class="img-box">
              <div class="img-description" style="border-radius: 0px 0px 12px 0px;">
                <div>
                  <h2>{{ $t('Home.Home.Pajamas') }}</h2>
                  <a href="/product-list/Women/Pajamas-Loungewear" target="_blank"><el-button type="primary"> {{$t('Home.Home.ShopNow')}}</el-button></a>
                </div>
              </div>
              <oss-img :width="248" style="border-radius: 0px 0px 12px 0px;" :height="320" src="https://img.kakaclo.com/web-img/home/Slice%202589%402x(7).png" alt="img" />
            </div>
          </div>
          <div class="pointer view-more" @click="jumpHref('/mall')">{{ $t('Home.Home.ViewAll') }} <i class="iconfont icon-arrow-right-line"></i></div>
        </div>
      </div>

      <!-- 销量展示区域 -->
      <div class="sales-volume">
        <div class="sales-box">
          <div class="text">
            <h2>{{ $t('Home.Home.Tips3') }}</h2>
            <p>  {{ $t('Home.Home.Tips4') }} </p>
          </div>
          <div class="sales f f-b-c">
            <div class="sales-item">
              <div class="number">8,600+</div>
              <div class="describe">{{ $t('Home.Home.ClothingWithCooperated') }}</div>
            </div>
            <div class="sales-item">
              <div class="number">11,000+</div>
              <div class="describe">{{ $t('Home.Home.TrustedByFashion') }}</div>
            </div>
            <div class="sales-item">
              <div class="number">Low MOQ</div>
              <div class="describe">{{ $t('Home.Home.RequireFor') }}</div>
            </div>
            <div class="sales-item">
              <div class="number">24/7</div>
              <div class="describe">{{ $t('Home.Home.OfferInClass') }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 支持的站点 -->
      <div class="supported-site f-b-c">
        <a class="site-img" href="https://www.presseportal.ch/de/pm/100089245/100885125" target="_blank">
          <oss-img :width="320" :height="90" src="https://img.kakaclo.com/web-img/home/link_icon1.png" alt="img" />
        </a>
        <a class="site-img" href="https://finance.yahoo.com/news/kakaclo-rolls-ai-feature-help-153000538.html" target="_blank">
          <oss-img :width="320" :height="90" src="https://img.kakaclo.com/web-img/home/link_icon2.png" alt="img" />
        </a>
        <a class="site-img" href="https://www.prnewswire.com/news-releases/kakaclo-rolls-out-ai-feature-to-help-their-user-grasp-the-central-fashion-trends-on-instagram-301602609.html" target="_blank">
          <oss-img :width="320" :height="90" src="https://img.kakaclo.com/web-img/home/link_icon3.png" alt="img" />
        </a>
        <a class="site-img" href="https://www.fibre2fashion.com/news/textile-news/hong-kong-s-kakaclo-s-supply-chain-platform-now-online--279067-newsdetails.htm" target="_blank">
          <oss-img :width="320" :height="90" src="https://img.kakaclo.com/web-img/home/link_icon4.png" alt="img" />
        </a>
      </div>

      <!-- 分类畅销产品 -->
      <div style="max-width:1400px;margin: 0 auto;padding:104px 20px">
        <CategroyProductList />
      </div>

      <!-- 评论轮播图区域 -->
      <div class="customer-story">
        <h2>Customer Stories</h2>
        <div ref="parent" class="container">
          <div ref="child" class="store-list f">
            <div class="store-box">
              <div class="store-header f">
                <div class="avator"><oss-img :width="80" :height="80" src="https://img.kakaclo.com/web-img/home/avator%20(5).png" alt="img" /></div>
                <div>
                  <h6>TeArra</h6>
                  <p>iClosam, Founder</p>
                </div>
              </div>
              <div class="semi"><oss-img :width="35" :height="24" src="https://img.kakaclo.com/web-img/home/Slice%202545%402x(2).png" alt="img" /></div>
              <p>Setting up my Shopify account was the first step; finding the right dropshipping partner was the next. That's when I discovered KakaClo. Unlike other platforms, KakaClo stands out with its clothing specialization, offering an extensive range of styles and timely updates. Their fast logistics from China to the US have been a game-changer, ensuring my customers receive their orders swiftly.</p>
              <el-button @click="playPCVideo('https://img.kakaclo.com/web-img/home/video/video/6.mp4')">{{ $t('Home.Home.PlayVideo') }}</el-button>
            </div>
            <div class="store-box">
              <div class="store-header f">
                <div class="avator"><oss-img :width="80" :height="80" src="https://img.kakaclo.com/web-img/home/avator%20(2).png" alt="img" /></div>
                <div>
                  <h6>Mike</h6>
                  <p>Halton, Owner</p>
                </div>
              </div>
              <div class="semi"><oss-img :width="35" :height="24" src="https://img.kakaclo.com/web-img/home/Slice%202545%402x(2).png" alt="img" /></div>
              <p>Recognizing my inability to manage storage and shipping, I found a solution in KakaClo. This platform has revolutionized my inventory management, providing depth without the responsibility for unsold stock. Their 24/7 live customer support has been an invaluable resource, ensuring smooth operations and immediate assistance whenever needed.</p>
              <el-button @click="playPCVideo('https://img.kakaclo.com/web-img/home/video/video/3.mp4')">{{ $t('Home.Home.PlayVideo') }}</el-button>
            </div>
            <div class="store-box">
              <div class="store-header f">
                <div class="avator"><oss-img :width="80" :height="80" src="https://img.kakaclo.com/web-img/home/avator%20(3).png" alt="img" /></div>
                <div>
                  <h6>Diana</h6>
                  <p>PRESSFIY, Owner</p>
                </div>
              </div>
              <div class="semi"><oss-img :width="35" :height="24" src="https://img.kakaclo.com/web-img/home/Slice%202545%402x(2).png" alt="img" /></div>
              <p>Our collaboration with KakaClo Dropshipping has been transformative for our brand. The platform's diverse selection, featuring both new and established designers worldwide, has significantly boosted our sales. Their excellent customer service and efficient problem-solving have elevated my boutique, enabling us to reach new heights and better serve our customers.</p>
              <el-button @click="playPCVideo('https://img.kakaclo.com/web-img/home/video/video/5.mp4')">{{ $t('Home.Home.PlayVideo') }}</el-button>
            </div>
            <div class="store-box">
              <div class="store-header f">
                <div class="avator"><oss-img :width="80" :height="80" src="https://img.kakaclo.com/web-img/home/avator%20(4).png" alt="img" /></div>
                <div>
                  <h6>Tamara</h6>
                  <p>Brand Owner</p>
                </div>
              </div>
              <div class="semi"><oss-img :width="35" :height="24" src="https://img.kakaclo.com/web-img/home/Slice%202545%402x(2).png" alt="img" /></div>
              <p>I stumbled upon KakaClo while searching for a reliable dropshipping service for my Shopify store. What drew me to KakaClo was its specialization in fashion. Since partnering, I've seen a notable increase in my inventory's variety and a reduction in delivery times, thanks to their efficient logistics. Their quick product updates and 24/7 customer support set them apart from other platforms, enhancing my business significantly.</p>
              <el-button @click="playPCVideo('https://img.kakaclo.com/web-img/home/video/video/2.mp4')">{{ $t('Home.Home.PlayVideo') }}</el-button>
            </div>
            <div class="store-box">
              <div class="store-header f">
                <div class="avator"><oss-img :width="80" :height="80" src="https://img.kakaclo.com/web-img/home/avator%20(1).png" alt="img" /></div>
                <div>
                  <h6>Thomas</h6>
                  <p>Brand Owner</p>
                </div>
              </div>
              <div class="semi"><oss-img :width="35" :height="24" src="https://img.kakaclo.com/web-img/home/Slice%202545%402x(2).png" alt="img" /></div>
              <p>I found KakaClo through a colleague's recommendation. Their extensive range of products and efficient shipping from China have been game-changers for my business, allowing me to offer a wider variety of styles and faster deliveries than ever before. KakaClo’s after-sales service and inventory updates keep them ahead of the competition, contributing greatly to my store's growth.</p>
              <el-button @click="playPCVideo('https://img.kakaclo.com/web-img/home/video/video/1.mp4')">{{ $t('Home.Home.PlayVideo') }}</el-button>
            </div>
            <div class="store-box">
              <div class="store-header f">
                <div class="avator"><oss-img :width="80" :height="80" src="https://img.kakaclo.com/web-img/home/avator%20(6).png" alt="img" /></div>
                <div>
                  <h6>James</h6>
                  <p>Brand Owner</p>
                </div>
              </div>
              <div class="semi"><oss-img :width="35" :height="24" src="https://img.kakaclo.com/web-img/home/Slice%202545%402x(2).png" alt="img" /></div>
              <p>I discovered KakaClo when looking for an eco-friendly dropshipping partner. The choice was clear with their vast selection of styles and commitment to quality. Their fast shipping and responsive customer support have boosted my brand's reputation and sales.</p>
              <el-button @click="playPCVideo('https://img.kakaclo.com/web-img/home/video/video/4.mp4')">{{ $t('Home.Home.PlayVideo') }}</el-button>
            </div>
          </div>
        </div>
        <div class="bar-box f f-c-c">
          <div class="pointer bar" @click="moveRight" v-show="toRight || toRight&&toLeft"> <oss-img :width="60" :height="60" src="https://img.kakaclo.com/web-img/home/Slice%202523%402x%20(1).png" alt="img" /></div>
          <div class="bar" style="cursor: not-allowed;" v-show="toLeft"> <oss-img :width="60" :height="60" src="https://img.kakaclo.com/web-img/home/Slice%202523%402x%20(2).png" alt="img" /></div>
          <div class="bar" style="cursor: not-allowed;" v-show="!toLeft&&!toRight"> <oss-img :width="60" :height="60" src="https://img.kakaclo.com/web-img/home/Slice%202523%402x(2).png" alt="img" /></div>
          <div class="pointer bar" @click="moveLeft" v-show="!toLeft"> <oss-img :width="60" :height="60" src="https://img.kakaclo.com/web-img/home/Slice%202523%402x(1).png" alt="img" /></div>
        </div>
      </div>

      <!-- FAQ区域 -->
      <div class="faq">
        <div class="box">
          <h2 class="title1">{{ $t('Home.Home.FrequentlyAskedQuestions') }}</h2>
          <el-collapse v-model="activeNames" @change="handleCollapseChange">
            <el-collapse-item :title="$t('Home.Home.HowLongDoesTheShippingTake1')" name="1" class="questions">
              <div class="answer">{{ $t('Home.Home.HowLongDoesTheShippingTake2') }}</div>
            </el-collapse-item>
            <el-collapse-item :title="$t('Home.Home.WhatIsFashionTrend1')" name="2" class="questions">
              <div class="answer">{{ $t('Home.Home.WhatIsFashionTrend2') }}</div>
            </el-collapse-item>
            <el-collapse-item :title="$t('Home.Home.Minimum1')" name="3" class="questions">
              <div class="answer">{{ $t('Home.Home.Minimum2') }}</div>
            </el-collapse-item>
            <el-collapse-item :title="$t('Home.Home.SyncProducts1')" name="4" class="questions">
              <div class="answer">{{ $t('Home.Home.SyncProducts2') }}</div>
            </el-collapse-item>
            <el-collapse-item :title="$t('Home.Home.SellOrFrom1')" name="5" class="questions">
              <div class="answer">
                {{ $t('Home.Home.SellOrFrom2') }}<br />
                {{ $t('Home.Home.SellOrFrom3') }}
              </div>
            </el-collapse-item>
            <el-collapse-item :title="$t('Home.Home.CustomizationService1')" name="6" class="questions">
              <div class="answer">
                {{ $t('Home.Home.CustomizationService2') }}<br />
                {{ $t('Home.Home.CustomizationService3') }}
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>

      <!-- 引导登录注册区域 -->
      <promotion-module-1></promotion-module-1>
    </div>

    <!-- 移动端 -->
    <Mobile v-else @playVideo="playMpbileVideo" />

    <div v-if="showPCVideo" style="width: 100%; height: 100%; background-color: #212326; position: fixed; left: 0; top: 0; z-index: 2011">
      <el-dialog :visible.sync="showPCVideo" width="60%">
        <video style="width: 100%" autoplay="autoplay" muted="false" loop controls>
          <source :src="videoPCUrl" type="video/mp4" />
        </video>
      </el-dialog>
    </div>

    <div v-if="showMpbileVideo" style="width: 100%; height: 100%; background-color: #212326; position: fixed; left: 0; top: 0; z-index: 2011">
      <el-dialog :visible.sync="showMpbileVideo" class="mpbile-dialog" width="100%">
        <video style="width: 100%" autoplay="autoplay" muted="false" loop controls>
          <source :src="videoMpbileUrl" type="video/mp4" />
        </video>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Mobile from './Mobile.vue'
import Banner from './Banner.vue'
import PromotionModule1 from './components/PromotionModule1.vue'
import CategroyProductList from '../../components/CategroyProductList.vue'
export default {
  metaInfo: {
    title: 'Boutique Clothing Wholesale, Custom, Dropshipping Supplier – KakaClo',
    meta: [
      {
        name: 'description',
        content: "Leading Clothing Wholesale, Custom, Dropshipping Supplier, Offering Abundant Affordable Women's, Men's, Children's, Holiday Attire, and Accessories Wholesale"
      }
    ]
  },
  name: 'PCHome',
  components: {
    Mobile,
    Banner,
    PromotionModule1,
    CategroyProductList
  },
  data() {
    return {
      show: 1,
      toLeft: false,
      toRight: false,
      email: '',
      email2: '',
      showPCVideo: false,
      videoPCUrl: '',
      activeNames: ['1'],
      showMpbileVideo: false,
      videoMpbileUrl: '',
      offset: 0,
      playerVars: {
        autoplay: 1,
        controls: 0,
        modestbranding: 1
      },
      childWidth: 442 // 子元素的宽度
    }
  },
  computed: {
    userId() {
      return this.$store.state.common.userId
    }
  },
  methods: {
    jump(path, event_id) {
      // if (['/product-list', '/mall'].includes(path)) {
      //   window.open(process.env.VUE_APP_MAIN_DOMAIN + path)
      //   return
      // }
      if (['/album/kakaclo-latest-fashion-arrivals'].includes(path)) {
        location.href = path
        return
      }
      this.$router.push(path)
    },
    jumpHref(path) {
      location.href = path
    },

    playPCVideo(url) {
      this.videoPCUrl = url
      this.showPCVideo = true
    },

    playMpbileVideo(url) {
      this.videoMpbileUrl = url
      this.showMpbileVideo = true
    },

    sendEmail() {
      this.$router.push({
        name: '/register',
        params: {
          email: this.email
        }
      })
    },

    sendEmail2() {
      this.$router.push({
        name: '/register',
        params: {
          email: this.email2
        }
      })
    },
    moveLeft() {
      let parentWidth = this.$refs.parent.offsetWidth
      let childWidth = this.$refs.child.offsetWidth
      let childRightOffset = parentWidth - (childWidth + this.offset)
      if (Math.abs(childRightOffset) > this.childWidth) {
        this.offset -= this.childWidth
        this.toRight = true
      } else if (childRightOffset < 0 && Math.abs(childRightOffset) <= this.childWidth) {
        this.offset -= Math.abs(childRightOffset)
        this.toLeft = true
      }
      console.log(childRightOffset, 'childRightOffset')
      this.$refs.child.style.transform = `translateX(${this.offset}px)`
    },
    moveRight() {
      let parentWidth = this.$refs.parent.offsetWidth
      let childWidth = this.$refs.child.offsetWidth
      if (this.offset < 0 && Math.abs(this.offset) > this.childWidth) {
        this.offset += this.childWidth
        this.toLeft = false
      } else if (this.offset < 0 && Math.abs(this.offset) <= this.childWidth) {
        this.offset = 0
        this.toLeft = false
        this.toRight = false
      }
      this.$refs.child.style.transform = `translateX(${this.offset}px)`
    },
    handleCollapseChange(newActiveNames) {
      this.activeNames = newActiveNames.slice(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './css/home.scss';
@import './css/homeOld.scss';
.youtube-video {
  width: 100%;
  max-width: 800px;
  height: 800px;
  margin: 0 auto;
}
</style>
